// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__2Kkx_","card":"styles_card__wrl5Q"};